module.exports = __webpack_public_path__ + "img/img2.7a53235c.png";